/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SalePOSPage = lazyLoad(
  () => import('./index'),
  module => module.SalePOSPage
);
